export async function getVersion() {
    try {
        const response = await fetch(`/version.json?t=${Date.now()}`, {
            cache: "no-store",
        });

        if (!response.ok) {
            return { version: "dev" };
        }

        return response.json();
    } catch (e) {
        return { version: "dev" };
    }
}